import { AppUpdateStatus } from '../types/app-settings.types';
import { compareSemver, isSemver } from './semver.utils';
export const DEFAULT_UPDATE_NOTICE_INTERVAL_HOURS = 24;
export const MAX_UPDATE_NOTICE_INTERVAL_HOURS = 8760;
export const APP_SETTINGS_VERSION_FIELDS = [
    'onboardingMinVersion',
    'iosLatestVersion',
    'iosMinVersion',
    'androidLatestVersion',
    'androidMinVersion',
];
const ALL_PLATFORMS = ['ios', 'android'];
const PLATFORM_LABEL = { ios: 'iOS', android: 'Android' };
function versionsFor(versions, platform) {
    return platform === 'ios'
        ? { latest: versions.iosLatestVersion, min: versions.iosMinVersion }
        : { latest: versions.androidLatestVersion, min: versions.androidMinVersion };
}
function validVersion(value) {
    return value && isSemver(value) ? value : undefined;
}
export function getAppUpdateStatus(versions, platform, installedVersion) {
    if (!isSemver(installedVersion)) {
        return { status: AppUpdateStatus.NONE };
    }
    const configured = versionsFor(versions, platform);
    const latest = validVersion(configured.latest);
    const min = validVersion(configured.min);
    if (min && compareSemver(installedVersion, min) < 0) {
        return { status: AppUpdateStatus.REQUIRED, latestVersion: latest ?? min };
    }
    if (latest && compareSemver(installedVersion, latest) < 0) {
        return { status: AppUpdateStatus.AVAILABLE, latestVersion: latest };
    }
    return { status: AppUpdateStatus.NONE };
}
export function findAppUpdateConfigError(versions, platforms = ALL_PLATFORMS) {
    for (const platform of platforms) {
        const { latest, min } = versionsFor(versions, platform);
        const label = PLATFORM_LABEL[platform];
        if (min && !latest) {
            return `${label}: set the latest store version before setting a minimum version`;
        }
        if (min && latest && compareSemver(min, latest) > 0) {
            return `${label}: the minimum version ${min} is higher than the latest store version ${latest}`;
        }
    }
    return undefined;
}
//# sourceMappingURL=app-update.utils.js.map